/*
 * When loading sources directly with <script type="module"> replace the line below with
 *   export * from '../../../dicom-parser/src/index.js';
 */

export * from 'cornerstone-dicom-parser-utf8';



// WEBPACK FOOTER //
// ./imageLoader/cornerstone-dicom-parser-utf8.js